import * as actionTypes from '../actions/actionTypes';

const { LOGIN, LOGOUT, SET_AUTH_STATE } = actionTypes;

const auth = {
  [LOGIN](state, payload) {
    state.user = payload;
  },
  [LOGOUT](state) {
    state.user = null;
  },
  [SET_AUTH_STATE](state, payload) {
    state.authState = payload;
  }
};

export default auth;
